export default __webpack_public_path__ + "assets/images/c2c16ba88c52005433b67394bba3cb8f.jpg";